import { useWorkspaceStore } from "@/store/workspace-store";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router";
import { LoadingSpinner } from "../ui/loading-spinner";
import { WorkspaceLoadError } from "./workspace-load-error";

export function LegacyRouteHandler() {
  const location = useLocation();
  const {
    activeWorkspace,
    workspaces,
    isInitialized,
    initError,
    initializeWorkspaces,
  } = useWorkspaceStore();

  console.log("🔍 LegacyRouteHandler: Current state", {
    isInitialized,
    workspacesCount: workspaces.length,
    activeWorkspace: activeWorkspace?.opportunity_name,
    currentPath: location.pathname,
  });

  useEffect(() => {
    // Initialize workspaces if not already initialized
    if (!isInitialized && !initError) {
      console.log("🔍 LegacyRouteHandler: Initializing workspaces...");
      initializeWorkspaces().catch((error) => {
        console.error(
          "❌ LegacyRouteHandler: Failed to initialize workspaces:",
          error
        );
      });
      return;
    }
    console.log("🔍 LegacyRouteHandler: Workspaces initialized");
  }, [isInitialized, initializeWorkspaces]);

  if (initError) {
    return <WorkspaceLoadError />;
  }

  // Show loading while initializing
  if (!isInitialized) {
    console.log("🔍 LegacyRouteHandler: Still initializing, showing loading");
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  // Determine which workspace to use
  const workspaceToUse = activeWorkspace || workspaces[0];
  console.log(
    "🔍 LegacyRouteHandler: Workspace to use:",
    workspaceToUse?.opportunity_name
  );

  if (!workspaceToUse) {
    // No workspaces available - redirect to workspace creation or error
    console.log(
      "🔍 LegacyRouteHandler: No workspaces available, redirecting to /workspaces"
    );
    return <Navigate to="/workspaces" replace />;
  }

  // Build the new path with workspace ID
  const newPath = `/${workspaceToUse._id}${location.pathname}`;

  // Preserve any search params and hash
  const fullPath = `${newPath}${location.search}${location.hash}`;

  console.log("🔍 LegacyRouteHandler: Redirecting to:", fullPath);
  return <Navigate to={fullPath} replace />;
}
